import { DEFAULT_PAGE_SIZE_PLANNER_ASSIGNMENTS } from '@/lib/constants/pagination';
import { PaginatedResponse } from '@/modules/common';
import { ApiErrorCode, withApiErrorHandler } from '@/modules/common/api/errors';
import { axiosInstance } from '@/utils/axios';

import {
  GetAssignmentsForPlannerByDepartmentRequest,
  PlannerDepartmentResponse,
} from '../types/dto';

export const getAssignmentsByDepartment = async ({
  filters,
  pagination,
  utilizationBasedOn,
  utilizationFilters,
  ignorePlaceholdersForGroup,
}: GetAssignmentsForPlannerByDepartmentRequest) => {
  const endpoint = '/api/assignments/planner/by-department/search';

  const apiData = await withApiErrorHandler(endpoint, ApiErrorCode.ASSIGNMENT_LOAD_FAILED, () =>
    axiosInstance.post<{
      data: PaginatedResponse<PlannerDepartmentResponse>;
      error?: { status: number; message: string; code: string };
    }>(endpoint, {
      filters,
      utilizationBasedOn,
      utilizationFilters,
      ignorePlaceholdersForGroup,
      pagination: pagination ?? {
        pageSize: DEFAULT_PAGE_SIZE_PLANNER_ASSIGNMENTS,
        cursor: null,
      },
    })
  );

  return new PaginatedResponse({
    items: apiData.items ?? [],
    pagination: apiData.pagination,
  });
};
